import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plane, Factory } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Spinner } from "../components/common";

export default function Aircraft() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const [mfrs, setMfrs] = useState([]);

  useEffect(() => { api.get("/manufacturers").then((r) => setMfrs(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    setItems(null);
    const t = setTimeout(() => api.get("/aircraft", { params: { q } }).then((r) => setItems(r.data)), q ? 250 : 0);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="aircraft-page">
      <PageHeader eyebrow="Directory" title="Aircraft & Manufacturers"
        subtitle="Every aircraft type in the network — with encyclopaedia references, operators and live news." />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-wrap items-center gap-2 mb-6">
          <Link to="/manufacturers" data-testid="all-manufacturers" className="inline-flex items-center gap-1.5 border border-primary text-primary px-3 py-1.5 text-sm font-500 hover:bg-blue-50 transition-colors">
            <Factory className="w-4 h-4" /> All manufacturers
          </Link>
          {mfrs.slice(0, 8).map((m) => (
            <Link key={m.name} to={`/manufacturers/${encodeURIComponent(m.name)}`}
              className="border border-zinc-300 bg-white px-3 py-1.5 text-sm hover:border-primary transition-colors">
              {m.name} <span className="text-muted-foreground font-mono text-xs">{m.count}</span>
            </Link>
          ))}
        </div>

        <input data-testid="aircraft-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search aircraft (e.g. 747, A320, Dreamliner)…"
          className="w-full border border-zinc-300 bg-white px-4 py-3 outline-none focus:ring-2 focus:ring-primary mb-6" />

        {!items ? <Spinner /> : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 pb-16">
            {items.map((a) => (
              <Link key={a.id} to={`/aircraft/${encodeURIComponent(a.iata || a.icao || a.id)}`} data-testid={`aircraft-card-${a.iata || a.id}`}
                className="group border border-zinc-300 bg-white p-4 flex items-center justify-between hover:-translate-y-px hover:border-primary transition-[transform,border-color]">
                <div className="min-w-0">
                  <div className="font-heading font-700 truncate">{a.name}</div>
                  <div className="text-xs text-muted-foreground mt-0.5">{a.manufacturer}</div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  {a.iata && <span className="font-mono text-primary text-sm">{a.iata}</span>}
                  <Plane className="w-4 h-4 text-zinc-400 -rotate-45 group-hover:text-primary transition-colors" />
                </div>
              </Link>
            ))}
            {items.length === 0 && <p className="text-muted-foreground">No aircraft found.</p>}
          </div>
        )}
      </div>
    </div>
  );
}
